// extracted by mini-css-extract-plugin
export default {"link":"TermsModal_link__Pvl3S"};